import { useNavigate } from "react-router-dom";
import { XCircle, RotateCcw } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
    const navigate = useNavigate();
    return (
        <div className="max-w-xl mx-auto px-4 sm:px-6 py-16">
            <Card className="bg-card border-border p-8 text-center" data-testid="payment-cancel-card">
                <span className="grid place-items-center h-16 w-16 rounded-full bg-secondary text-muted-foreground mx-auto mb-4">
                    <XCircle className="h-9 w-9" />
                </span>
                <h1 className="font-heading text-2xl font-bold" data-testid="payment-cancel-status-text">Payment canceled</h1>
                <p className="text-muted-foreground mt-2">No charge was made and nothing was listed. You can try again whenever you&apos;re ready.</p>
                <div className="mt-6 flex flex-col sm:flex-row gap-3">
                    <Button data-testid="cancel-retry-button" onClick={() => navigate("/outbid")} className="flex-1 bg-brand text-primary-foreground hover:bg-brand-dim font-semibold">
                        <RotateCcw className="h-4 w-4 mr-2" /> Try again
                    </Button>
                    <Button data-testid="cancel-leaderboard-button" variant="outline" onClick={() => navigate("/")} className="flex-1 font-semibold">
                        Back to leaderboard
                    </Button>
                </div>
            </Card>
        </div>
    );
}
